import {SpanIcon} from '@mazraeapp/react_icon_kit';
import classNames from 'classnames';

import defaultImg from '../../../../assets/image/newShop/defaultImg.png';

interface SecondaryCardProps {
  title: string;
  city: string;
  state: string;
  logo: string | null;
  rate?: number;
  cardWrapperClassName?: string;
  input_groups?: IInputGroups[];
  guid: string;
  onClick?: () => void;
}
const SecondaryCard = ({
  title,
  city,
  state,
  logo,
  rate,
  input_groups,
  cardWrapperClassName,
  onClick,
}: SecondaryCardProps) => {
  return (
    <div
      className={classNames(
        'flex relative gap-2 items-center px-2 py-2 bg-white shadow-sm  h-[128px] rounded-[8px]',
        cardWrapperClassName,
      )}
      onClick={onClick}
    >
      {/* Rating Star */}
      {rate ? (
        <div className="flex rounded-[50px] w-[40px] justify-center py-1 px-2 gap-0.5 items-center h-[24px] absolute top-[10px] left-4 bg-gray-50">
          <SpanIcon className="icon-nameStar text-[#F2AE24] text-[14px]" />
          <span className="text-md">{rate}</span>
        </div>
      ) : null}

      <div className="flex relative rounded-[8px] w-[88px] h-[88px] ">
        <img
          className="flex w-full h-full rounded-[8px] border object-cover"
          src={logo || defaultImg}
          alt={title}
          width={112}
          height={112}
        />
      </div>
      <div className="flex flex-col flex-1 justify-between py-2 h-full">
        <div className="flex flex-col text-md">
          <span className="mb-2 font-semibold line-clamp-1">{title}</span>
          <div className="flex gap-1 items-center text-sm text-gray-700">
            <SpanIcon className="icon-nameLocation1" />
            <span>
              {state} ، {city}
            </span>
          </div>
        </div>
        <div className="flex gap-2 overflow-x-auto mt-1 text-xs text-gray-700 min-w-[12rem]">
          {input_groups?.map((item, index) => (
            <span
              className="bg-gray-100 h-[24px] px-2 rounded-[50px] content-center w-fit whitespace-nowrap"
              key={index}
            >
              {item.title}
            </span>
          ))}
        </div>
      </div>
    </div>
  );
};

export default SecondaryCard;
